import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    standalone: false
})
export class ErrorModalComponent implements OnInit {

  @Input()
  description: string;
  
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  close(){
    this.activeModal.close();
  }

}
